export default __webpack_public_path__ + "static/media/Payment.327b2571.png";